import type { ComponentProps } from 'react'

import { Input as InputPrimitive } from '@base-ui/react/input'
import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: ComponentProps<'input'>) {
    return (
        <InputPrimitive
            type={type}
            data-slot='input'
            className={cn(
                'h-11 w-full min-w-0 rounded-xl border border-input bg-card px-3.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-primary/60 focus-visible:ring-4 focus-visible:ring-ring/25 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-4 aria-invalid:ring-destructive/15',
                className
            )}
            {...props}
        />
    )
}

export { Input }
